var en_US_default = {
  "request.response_status_code.400": "Bad request",
  "request.response_status_code.401": "Unauthorized",
  "request.response_status_code.403": "Forbidden",
  "request.response_status_code.404": "Not found",
  "request.response_status_code.408": "Request timeout",
  "request.response_status_code.500": "Internal server error",
  "request.response_status_code.502": "Bad gateway",
  "request.response_status_code.503": "Service unavailable",
  "request.response_status_code.504": "Gateway timeout",
  "request.response_status_code.other": "Connection error",
  "request.no_response": "Server no response",
  "request.error": "Request error",
  "login.btn.login": "Login",
  "login.btn.logout": "Logout",
  "login.btn.forgot_password": "Forgot Password",
  "login.btn.edit_password": "Edit Password",
  "login.captcha.phone": "Phone Number",
  "login.captcha.email": "Email",
  "login.placeholder.phone": "Please input phone number",
  "login.placeholder.email": "Please input email",
  "login.type.account": "Account Login",
  "login.type.captcha": "Captcha Login",
  "login.type.feishu": "Lark Login",
  "login.input.required": "Please input",
  "login.password.mismatch": "The two passwords you entered do not match!",
  "login.password.required": "Please input password",
  "login.verification.required": "Please input verification code",
  "login.verification.placeholder": "Please input verification code",
  "login.verification.get": "Get verification code",
  "login.password.confirm.required": "Please input confirm password",
  "login.password.confirm.placeholder": "Please input confirm password",
  "login.submit": "Submit",
  "login.password.new.placeholder": "Please input new password",
  "login.password.new.confirm.placeholder": "Please input confirm new password",
  "login.back": "Back to login",
  "login.phoneNumber.required": "Please input phone number"
};
export {
  en_US_default as default
};
